module.exports = __webpack_public_path__ + "static/media/hbonow-wide.4f3ba1d9.png";